<template>
  <form-wizard ref="add_service_estimates_form" color="#39C0ED"  @on-complete="addConfirmation">
    <h2 slot="title"></h2>
    
    <tab-content
      title="Registration"
      :before-change="() => validateStep('childVehicleComponent')"
    >

      <vehicle-card
        :vehicle.sync="vehicle"
        ref="childVehicleComponent"
      />
    </tab-content>
    <tab-content title="Document" :before-change="() => validateStep('childDocumentComponent')">
      <document-card
        :vehicle="vehicle"
        ref="childDocumentComponent"
      />
    </tab-content>
    <tab-content title="Accesories" :before-change="() => validateStep('childAccesoriesComponent')">
      <accesories-card
        :vehicle="vehicle"
        ref="childAccesoriesComponent"
      />
    </tab-content>
    
  </form-wizard>
</template>

<script>
import {ValidationError} from "@/components";
import formMixin from "@/mixins/form-mixin";
import { FormWizard, TabContent } from "vue-form-wizard";
import "vue-form-wizard/dist/vue-form-wizard.min.css";

// import komponen

import VehicleCard from "@/pages/Dashboard/Workshop/Vehicle/ComponentForm/VehicleCard.vue";
import DocumentCard from "@/pages/Dashboard/Workshop/Vehicle/ComponentForm/DocumentCard.vue";
import AccesoriesCard from "@/pages/Dashboard/Workshop/Vehicle/ComponentForm/AccesoriesCard.vue";
import Swal from "sweetalert2";

//  extend('useppn', {
//   ...required,
//   message: 'Use PPN field is required'
//   });
//   extend('dealername', {
//     ...required,
//     message: 'Dealer Name field is required'
//   });

export default {
  name: "add-vehicle",

  // props: {
  //   service_estimate: Object,
  // },

  components: {
    FormWizard,
    TabContent,
    "vehicle-card": VehicleCard,
    "document-card": DocumentCard,
    "accesories-card": AccesoriesCard,
  },

  mixins: [formMixin],

  data: () => ({
    vehicle: [],
  }),

  created() {
  },

  methods: {

    resetFile(ref) {
      this.$refs[ref].clearField()
    },


    
     sizeTobig(size){
      Swal.fire({
          icon: 'error',
          title: 'File is to big ('+(size / 1048576).toFixed(2)+'MB)',
          text: 'Maximum attachment file size 3MB',
        })
    },

    async addConfirmation() {
     
      Swal.fire({
        title: 'Are you sure?',
        text: 'The data will be saved!',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, save it!',
        cancelButtonText: 'No, cancel!',
        buttonsStyling: true
      }).then((result) => {
        if (result.value){
          this.addVehicle()
        }
      });
    },

    async addVehicle() {
      this.$refs.childVehicleComponent.getData()
      this.$refs.childDocumentComponent.getData()
      this.$refs.childAccesoriesComponent.getData()
      console.log(this.vehicle)
      const data = {
        type: "workshop_vehicles",

        vehicle_door_no : this.vehicle.vehicle_door_no,
        vehicle_pool: this.vehicle.vehicle_pool,
        // vehicle_business_unit_id: this.vehicle.vehicle_business_unit_id,
        vehicle_body_color: this.vehicle.vehicle_body_color,
        vehicle_plate_color: this.vehicle.vehicle_plate_color,
        vehicle_registration_year: this.vehicle.vehicle_registration_year,
        vehicle_registration_name:this.vehicle.vehicle_registration_name,
        vehicle_type_id: this.vehicle.vehicle_type,
        vehicle_plate_no: this.vehicle.vehicle_plate_no,
        vehicle_production_year: this.vehicle.vehicle_production_year,
        vehicle_chassis_no: this.vehicle.vehicle_chassis_no,
        vehicle_engine_no: this.vehicle.vehicle_engine_no,
        vehicle_document: this.vehicle.document,
        vehicle_accessory: this.vehicle.accesories,


        
      };

      console.log(data);
      try {
        await this.$store.dispatch("workshop_vehicle/add", data);
        await this.$store.dispatch(
          "alerts/success",
          "Successfully registered."
        );
        // await this.$router.push({ name: "List Vehicle" });
        this.$parent.$parent.modalCloseAdd();

      } catch (e) {
        await this.$store.dispatch(
          "alerts/error",
          "Oops, something went wrong"
        );
      //  this.setApiValidation(e.response.data.errors);
      }
    },

    //set data yang diambil dari child
    // dataNote (value) {
    //   this.vehicle.note = value
    // },


   //checke validasi stiap child sebulum pindah section
    validateStep(name) {
      
      var refToValidate = this.$refs[name]
      return refToValidate.validateForm()
    },
    
  },
  mounted() {
    console.log("Component mounted.");
  },
};
</script>
<style scoped>
.md-layout-item{
  margin-top:10px;
}
</style>
